import { render, staticRenderFns } from "./ManageOrganisations.vue?vue&type=template&id=568f1bc0&"
import script from "./ManageOrganisations.vue?vue&type=script&lang=js&"
export * from "./ManageOrganisations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports